import { useEffect, useRef } from "react";

import { UserStorageKeys } from "@libs/gateways/user-experience/UserExperienceGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";

export const usePersistDraftFilter = () => {
  const { userExperience, routing } = useStores();
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }

    userExperience.saveToUserStorage(
      UserStorageKeys.DraftItemsFilters,
      routing.location.search
    );
  }, [userExperience, routing.location.search]);
};
